export default __webpack_public_path__ + "static/media/arrow_blue.b2045736.svg";